const signInPageTranslations = {
  intro: {
    title: "Hi There!",
    subtitle: "Welcome To Your First Of It's Kind Online Coaching Experience.",
    signUpText: "Dont Have An Account ?!",
    signUpLink: "Sign Up",
  },
  heroSection: {
    brandingText: "New Of It's Kind Exclusive Coaching Experience",
    hookText:
      "You Are One Step Away From The Exlusive Experiecne You Always Deserved.",
  },
  form: {
    email: "Email",
    password: "Password",
    action: "Sign In",
  },
};

export default signInPageTranslations;
